<template>
  <div class="user-feedbacks-main" :style="iosOrAndroidStyle">

    <w-nav-bar
      :icon="'iconchevron-left'"
      nav_title="问题反馈"
      @mobileLeftBtn="leftBtnClick"
      v-show="iosOrAndroidShow"
    />

    <cube-input class="margin-t-15" v-model="user_email" placeholder="请留下您的联系邮箱"/>

    <cube-select
      class="margin-t-15"
      v-model="feedback_type"
      placeholder="请选择反馈类型"
      :options="options"/>

    <cube-textarea class="margin-t-15" v-model="content" height="170px" placeholder="请描述您的具体问题或建议" :maxlength="1000"/>

    <div class="margin-t-15">添加图片说明({{images.length}}/3)</div>

    <cube-upload
      class="margin-t-15"
      :simultaneous-uploads="1"
      :max="3"
      v-model="img"
      @files-added="filesAdded"
      @file-removed="fileRemoved"/>

    <div class="qrcode" v-if="!isAlipayClient && !isUCClient && !isQuaReClient">
      <p class="title">公众号后台留言</p>
      <p class="msg margin-t-6">微信上也可以随时查看、 编辑简历</p>
      <img src="https://files.wondercv.com/default_wx_qr.png" alt="">
      <p class="msg">微信扫码 反馈问题</p>
    </div>

    <button class="submit" @click="submit">提交</button>


  </div>
</template>
<script>
import { envMixin, windowEventMixin } from '@/assets/js/mixin/global';
import { componentsMixin } from '../../assets/js/mixin/components'
import WNavBar from "@/components/global/w-navbar";
import Item from './components/item';
import Cookies from "js-cookie";
export default {
  name: 'Feedbacks',
  mixins: [ envMixin, componentsMixin ],
  components: {
    WNavBar,
    Item
  },
  data() {
    return {
      options: [
        {
          value: 0,
          text: "BUG反馈"
        },
        {
          value: 1,
          text: '简历功能'
        },
        {
          value: 2,
          text: "求职信/邮件功能"
        },
        {
          value: 3,
          text: "会员功能"
        },
        {
          value: 4,
          text: "导师辅导"
        },
        {
          value: 5,
          text: "其他功能"
        }
       ],
      user_email: '', // 邮箱
      feedback_type: null,
      content: '', // 内容
      images: [],
      img: [],
      feedback_platform: 'mobile_vue'
    };
  },
  methods: {
    leftBtnClick() {
      this.$router.back();
    },

    async submit() {
      let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9-])+((\.[a-zA-Z0-9-]{2,3}){1,2})$/gim;
      if (!reg.test(this.user_email)) {
        this.showToast('请正确填写邮箱');
        return false;
      }
      if (this.feedback_type == null) {
        this.showToast('请选择反馈类型');
        return false;
      }
      if (!this.content) {
        this.showToast('请填写具体问题和建议');
        return false;
      }
      let _t = Cookies.get("_t");
      let tokenPayload = JSON.parse(window.atob(_t.split(".")[1]));
      let params = {
        user_email: this.user_email,
        feedback_type: this.feedback_type,
        content: this.content,
        images: this.images,
        feedback_platform: this.feedback_platform,
        cv_account_token: tokenPayload.User.c_t
      };
      let res = await this.$api.user.feedbackSubmit(params);
      if (res.code === 1000) {
        this.showToast('提交成功，感谢你的反馈');
        setTimeout(() => {
          this.leftBtnClick();
        }, 300);
      }
      else {
        this.showToast('提交失败');
      }
    },

    filesAdded(data) {
      var file =data[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = event => {
        var url = event.target.result;
        this.images.push(url);
      }
    },

    fileRemoved(data) {
      console.log(data);
      var file =data.file;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = event => {
        var url = event.target.result;
        this.images.splice(this.images.indexOf(url), 1);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.user-feedbacks-main {
  padding: 44px 24px 80px;
  overflow: hidden;
  .margin-t-6 { margin-top: 6px; }
  .margin-t-15 { margin-top: 15px; }
  .qrcode {
    text-align: center;
    margin-top: 36px;
    img {
      width: 150px;
      height: 150px;
      margin: 18px auto 22px;
    }
    .title {
      font-size: 16px;
      font-weight: 700;
      color: #404040;
    }
    .msg {
      font-size: 14px;
      color: #9c9c9c;
    }
  }
  .submit {
    // margin: 0 24px;
    background: #ff4f4c!important;
    height: 42px;
    width: calc(100% - 48px);
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    border: none;
    position: fixed;
    bottom: 10px;
    left: 24px;
    z-index: 2;
    border-radius: 4px;
  }
}
</style>
<style lang="scss">
.user-feedbacks-main {
  .cube-input:after,
  .cube-select::after,
  .cube-textarea-wrapper::after {
    // border-width: 3px!important;
    border-color: #dedede!important;
  }
}
</style>
